<!-- 显示屏详情 -->
<template>
    <displayDetail :isDetailShow.sync="isDetailShow" :shiquArray="shiquArray" :title="title" :detailObj="detailObj"
       :detailNetObj="detailNetObj" :deviceProperty="deviceProperty" v-bind="$attrs" :deviceType="deviceType" :loading="loading"></displayDetail>
</template>

<script>
import displayDetail from './component/displayDetail.vue'
import {
  contentList,
  displayGetDisplayDetailInfo
} from '@/api/modules/display.js'
import bus from '@/utils/bus'
export default {
  props: ['show'],
  data () {
    return {
      title: '',
      detailNetObj: {},
      deviceType: {},
      deviceProperty: {},
      detailObj: {},
      isDetailShow: false,
      shiquArray: [],
      loading: false
    }
  },
  watch: {
    isDetailShow (newval) {
      this.$emit('update:show', newval)
    }
  },
  components: {
    displayDetail
  },
  methods: {
    detailFn (id, name, scopeName) {
      this.loading = true
      this.isDetailShow = true
      this.title = `[${name}]${this.$t('public.details')}`
      displayGetDisplayDetailInfo(id).then(({ result }) => {
        // 处理url 因为显示屏是一对多 所以需要特殊处理
        let url = []
        const pictureBase64 = result.display.pictureBase64 || result.deviceType.pictureBase64

        result.display.carrierRspList.forEach(item => {
          url.push(item.fullPath)
        })

        url = [...new Set(url)]
        if (!url.length) { url = [scopeName] }

        const { appConfig, display, netConfig } = result
        this.detailObj = Object.assign({}, { ...display }, { url, pictureBase64 })
        this.detailNetObj = netConfig || {}
        this.deviceType = result.deviceType
        this.deviceProperty = result.deviceProperty || {}
      }).finally(() => {
        this.loading = false
      })
    },
    /** 时区 */
    contentListFn () {
      if (this.shiquArray.length > 0) return
      contentList({ code: 'ADMIN_CONFIG_LABEL_NOTICE_ZONE', type: 0 }).then(({ result }) => {
        this.shiquArray = result
      })
    }
  },
  mounted () {
    bus.$on('displayParam', (id, name, scopeName) => {
      this.contentListFn()
      this.detailFn(id, name, scopeName)
    })
  },
  beforeDestroy () {
    bus.$off('displayParam')
  }
}
</script>

<style>

</style>
